module.exports = __webpack_public_path__ + "assets/img/travel-day30.7a5fb8ed.png";